function showLoader() {
  document.getElementById("overlay").style.display = "block";
}

function hideLoader() {
  document.getElementById("overlay").style.display = "none";
}

function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count-number").forEach((el) => {
    el.textContent = count;
  });
  document.querySelector(".cart-count-number").classList.add("iha-cart-count");
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const rescount = await fetch("/cart.js");
  const cartcount = await rescount.json();
  const itemCount = cartcount.item_count;
  const newBox = html.querySelector(".cart-drawer-items").innerHTML;
  const total_price = html.querySelector(".cart-drawer-footer-row").innerHTML;

  document.querySelector(".cart-drawer-items").innerHTML = newBox;
  document.querySelector(".cart-drawer-footer-row").innerHTML = total_price;

  if (itemCount > 0) {
    document.querySelector(".cart-drawer-empty").style.display = "none";
    document.querySelector(".cart-drawer-footer").style.display = "block";

    showLoader();
  } else {
    document.querySelector(".cart-drawer-footer").style.display = "none";
    document.querySelector(".cart-drawer-empty").style.display = "block";
  }
  const resdata = await fetch("/cart.js");
  const cartData = await resdata.json();
  const checkbox = document.querySelector(
    '.option-subscription input[type="checkbox"]'
  );
  const lineItems = cartData.items.map((item) => String(item.id)); // Convert item IDs to strings
  console.log(lineItems);
  if (lineItems.includes("3083624022056")) {
    checkbox.checked = true;
  } else {
    checkbox.checked = false;
  }
  updateCartItemCounts(cartData.item_count);
  hideLoader();
  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem = button.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {
              [key]: newQuantity,
            },
          }),
        });

        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
      });
    });

  document.querySelectorAll(".cart-drawer-quantity-selector-remove").forEach((removeButton) => {
      removeButton.addEventListener("click", async () => {
        const rootItem = removeButton.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");
        const newQuantity = 0;

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {
              [key]: newQuantity,
            },
          }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
      });
    });

  document.querySelector(".cart-drawer-wrapper").addEventListener("click", (e) => {
      e.stopPropagation();
    });

  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer").forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

function productFormListener() {
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // Check if 'data-bundle' attribute exists in the form
      const dataBundleAttribute = form.getAttribute("data-bundle");
      const resBefore = await fetch("/cart.js");
      const cartBefore = await resBefore.json();
      const itemCountBefore = cartBefore.item_count;

      if (dataBundleAttribute) {
        await fetch(form.action, {
          method: form.method,
          body: new FormData(form),
        });
      }

      const resAfter = await fetch("/cart.js");
      const cartAfter = await resAfter.json();

      // Form submission successful
      //updateCartItemCounts(cartAfter.item_count);
      updateCartDrawer();
      openCartDrawer();
    });
  });
}
productFormListener();

document.addEventListener("customer:cart", () => {
  updateCartDrawer();
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

document.querySelector('.option-subscription input[type="checkbox"]').addEventListener("change", async (e) => {
    const checkbox = e.target;
    const isChecked = checkbox.checked;
    const variantId = checkbox.value;
    console.log(isChecked);

    const res = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [variantId]: isChecked ? 1 : 0,
        },
      }),
    });

    const cartRes = await fetch("/cart.js");
    const cartData = await cartRes.json();
    updateCartItemCounts(cartData.item_count);
    updateCartDrawer();
    openCartDrawer();
  });

async function applyDiscount(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    var discountCode = document.getElementById("promo-code").value.trim();
    window.location.href =
      "/checkout?discount=" + encodeURIComponent(discountCode);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("checkout-form").addEventListener("submit", function (event) {
      event.preventDefault();
      var discountCode = document.getElementById("promo-code").value.trim();
      window.location.href =
        "/checkout?discount=" + encodeURIComponent(discountCode);
    });
});


/***** Add to cart for cart drawer products *****/

$('.custom-cart-button-wrapper .custom-cart-button').on('click', function(event) {
  event.preventDefault();
  
  const drawerProductId = $(this).closest('.custom-cart-button-wrapper').find('.drawer-product-id').val();
  const productData = {
    id: drawerProductId, 
    quantity: 1
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(productData)
  })
  .then(response => response.json())
  .then(data => {
    updateCartDrawer();
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  });
});

/***** Add to cart for cart drawer products *****/
